/* eslint-disable no-unused-vars */
import React from 'react';
import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import {
  Container, Logo, Message, ReportFeedback,
} from '../styles';

/**
 * This component does not use the error, componentStack and resetError props,
 * however they were already passed to the Falback component, I just kept them in case in the future if we need to use
 * @param {*} props
 */
const FallBack = (props) => {
  const { error, componentStack, resetError } = props;
  return (
    <Container>
      <Logo src="/images/playbook-logo.png" alt="Playbook" />

      <Message>We are sorry, an unexpected error occurred.</Message>

      <ReportFeedback onClick={Sentry.showReportDialog}>
        Report feedback
      </ReportFeedback>
    </Container>
  );
};

FallBack.propTypes = {
  error: PropTypes.shape({}),
  componentStack: PropTypes.string,
  resetError: PropTypes.func,
};

FallBack.defaultProps = {
  error: {},
  componentStack: '',
  resetError: () => {},
};

export default FallBack;
